import { useContext } from "react";
import { GameState } from "../GameState";
import MainMenuButton from "./MainMenuButton";

const MainMenu = () => {
  const state = useContext(GameState);
  return (
    <div className="mainmenu">
      <div className="maintitle">TAX EVASION</div>
      <div className="maintitle-sub">
        <div className="maintitle-sub-inner">
          <div>"In this world nothing can be said to be certain,</div>
          <div>except death and taxes." </div>
          <div>- Ben Franklin</div>
        </div>
      </div>
      <MainMenuButton name="PLAY" action={() => state.setGameMode(2)} />
      <MainMenuButton name="INSTRUCTIONS" action={() => state.setGameMode(1)} />
      <div className="credits">
        <div className="creditsrow">
          Code and Design by{" "}
          <a
            href="https://github.com/verifiedtm"
            target="_blank"
            rel="noreferrer"
          >
            Tim
          </a>{" "}
          and{" "}
          <a
            href="https://github.com/joshiemoore"
            target="_blank"
            rel="noreferrer"
          >
            Josh
          </a>
        </div>
        <div className="creditsrow">
          Music by{" "}
          <a
            href="https://twitter.com/BenFoster000"
            target="_blank"
            rel="noreferrer"
          >
            Ben Foster
          </a>
        </div>
        <div className="creditsrow-smol">
          Map by{" "}
          <a
            href="https://commons.wikimedia.org/wiki/File:Simplified_blank_world_map_without_Antartica_(no_borders).svg"
            target="_blank"
            rel="noreferrer"
          >
            Skimel
          </a>{" "}
          (Public Domain)
        </div>
      </div>
    </div>
  );
};

export default MainMenu;
